












































































import { EditMode, CabinetConfigurationModel, CabinetReferenceType, CabinetConfigurationLevel } from '@/types';
import MStoreAccordion from '@/components/shared/MStoreAccordion.vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import ReferencesAccordion from '@/components/configuration/cabinet/ReferencesAccordion.vue';
import CabinetSummaryInfoAlert from './CabinetSummaryInfoAlert.vue';
import Vue, { PropType } from 'vue';
import { CabinetConfigurationHelper, ComponentHelper, FormFieldValidation } from '@/mixins';
import { ObjectUtils } from '@/utils/objectUtils';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import CopyCabinetReferences from '@/components/configuration/cabinet/CopyCabinetReferences.vue';
import { mapActions } from 'vuex';
import { CabinetSummaryOptions } from '@/types/enums/configuration/cabinet/CabinetSummaryOptions';
import { StringUtils } from '@/utils';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'CabinetConfiguration',
  mixins: [FormFieldValidation, CabinetConfigurationHelper, ComponentHelper],
  data() {
    return {
      cabinetConfigurationClone: {} as CabinetConfigurationModel,
      cabinetSummaryOptionsDisplayed: [CabinetSummaryOptions.Id, CabinetSummaryOptions.DocumentTypes, CabinetSummaryOptions.DocumentLocation],
      isLoading: true,
      referencesHaveChanged: false
    };
  },
  props: {
    editMode: {
      type: Number as PropType<EditMode>,
      required: true
    },
    cabinetConfiguration: {
      type: Object as () => CabinetConfigurationModel,
      required: true
    },
    isSubmitting: {
      type: Boolean
    },
    allCabinetNames: {
      type: Array as PropType<string[]>,
      default: []
    }
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    cloneConfiguration(this: any) {
      if (!ObjectUtils.isNullOrEmpty(this.cabinetConfiguration)) {
        this.cabinetConfigurationClone = ObjectUtils.deepCloneObject(this.cabinetConfiguration);
      }
    },
    onReferencesChanged(this: any, cabinetConfiguration: CabinetConfigurationModel) {
      this.cabinetConfigurationClone = cabinetConfiguration;
      this.referencesHaveChanged = true;
    },
    onDirtyForm(this: any, isDirty: boolean) {
      if (!isDirty && this.referencesHaveChanged) {
        return;
      }
      this.setApplicationDirty(isDirty);
    },
    async onSubmitAsync(this: any) {
      this.resetFormValidation();
      if (!this.cabinetNameIsValid((this.cabinetConfigurationClone as CabinetConfigurationModel).description)) {
        this.scrollToCabinetName();
        return;
      }
      try {
        const isValid = await this.$validator.validate();
        if (!isValid) {
          return;
        }
        this.$emit('submit', this.cabinetConfigurationClone);
      } catch (error) {
        this.$log('', error);
      }
    },
    cabinetNameIsValid(this: any, cabinetName: string): boolean {
      const isValid: boolean =
        StringUtils.equalsIgnoreCase(cabinetName, (this.cabinetConfiguration as CabinetConfigurationModel).description) ||
        !(this.allCabinetNames as string[]).some((x) => StringUtils.equalsIgnoreCase(x, cabinetName));

      if (!isValid) {
        this.$refs.cabinetNameInput.applyValidationResult({
          errors: ['Name must be unique, existing cabinet has the same name'],
          valid: false,
          failedRules: {}
        });
      }
      return isValid;
    },
    scrollToCabinetName(this: any) {
      this.setScrollIntoViewById('cabinetName', { block: 'end', inline: 'nearest' });
    },
    onCancelButtonClicked(this: any) {
      this.$emit('cancel');
    },
    async checkAuthorizedAsync(this: any): Promise<boolean> {
      if (this.editMode !== EditMode.Add) {
        return true;
      }
      let authorized = false;
      try {
        await CabinetConfigurationService.checkAuthorizedWithErrorPageAsync();
        authorized = true;
      } catch (error) {
        this.$log(error);
      }
      return authorized;
    },
    onCopyCabinetSelected(this: any, value: CabinetConfigurationModel) {
      this.isLoading = true;
      this.$set(
        this.cabinetConfigurationClone,
        'cabinetReferences',
        value.cabinetReferences
          .filter((x) => x.referenceType === CabinetReferenceType.Common && !x.isDeleted)
          .map((reference) => {
            return { ...reference, id: null, canDelete: false, isNew: true, deletionDisabledReason: null };
          })
      );
      this.$set(this.cabinetConfigurationClone, 'commonSearchReferencesConfiguration', value.commonSearchReferencesConfiguration);
      this.$set(this.cabinetConfigurationClone, 'defaultCommonStoreReferencesConfiguration', value.defaultCommonStoreReferencesConfiguration);
      this.isLoading = false;
    }
  },
  computed: {
    cabinetAccordionTitle(this: any) {
      return this.editMode === EditMode.Add ? 'Add a Cabinet' : `Edit ${this.cabinetConfigurationClone.description} Cabinet`;
    },
    referenceCount(this: any) {
      return this.cabinetConfigurationClone.cabinetReferences?.length ?? 0;
    },
    isAddMode(this: any) {
      return this.editMode === EditMode.Add;
    },
    isViewMode(this: any) {
      return this.editMode === EditMode.View;
    }
  },
  async mounted(this: any) {
    const authorized = await this.checkAuthorizedAsync();
    if (authorized) {
      this.cloneConfiguration();
      this.checkLockedForEditMode(this.editMode);
    }
    this.isLoading = false;
  },
  created(this: any) {
    this.REFERENCE_TYPE = CabinetReferenceType.Common;
    this.CONFIGURATION_LEVEL = CabinetConfigurationLevel.Cabinet;
  },
  components: {
    MStoreAccordion,
    MStoreFormInput,
    ReferencesAccordion,
    CopyCabinetReferences,
    CabinetSummaryInfoAlert,
    MStoreSpinnerButton,
    MStoreFormCheckbox,
    LoadingSpinner
  }
});
